import Inspector from './inspector';
const { RichText, InnerBlocks } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const { title, text, margin } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section className={`SolutionSection ${margin}`}>
        <div className="Container">
          <div className="SolutionSection-col">
            <RichText
              tagName="h2"
              className="Typography title-4 left color-blue-dark margin-small"
              value={title}
              placeholder="Mais informações"
              keepPlaceholderOnFocus
              onChange={(title) => setAttributes({ title })}
            />

            <RichText
              tagName="p"
              className="Typography text left color-grey margin-base"
              value={text}
              placeholder="Mais informações"
              keepPlaceholderOnFocus
              onChange={(text) => setAttributes({ text })}
            />

            <div className="SolutionSection-accordion">
              <InnerBlocks
                template={[['app/item-solution-section']]}
                allowedBlocks={['app/item-solution-section']}
              />
            </div>
          </div>

          <div class="SolutionSection-wrapButtons">
            <div class="SolutionSection-prev"></div>
            <div class="SolutionSection-next"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Edit;
